import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "textField",
    "hiddenField"
  ]

  connect() {
    this._updateContentEditable()
    this._updateInitialTextFieldValue()
  }

  input() {
    this.hiddenFieldTarget.value = this.textFieldTarget.innerHTML
  }

  change(event) {
    if (this.hiddenFieldTarget.value !== this.initialTextFieldValue) {
      this.initialTextFieldValue = this.hiddenFieldTarget.value
      this.dispatch("change")
    }
  }

  handleKeyBindings(event) {
    if (event.metaKey || event.ctrlKey) {
      switch (event.key.toLowerCase()) {
        case "b":
          event.preventDefault()
          this._formatText("bold")
          break
        case "i":
          event.preventDefault()
          this._formatText("italic")
          break
        case "u":
          event.preventDefault()
          this._formatText("underline")
          break
      }
    }
  }

  _updateContentEditable() {
    this.textFieldTarget.setAttribute("contenteditable", true)
  }

  _formatText(command) {
    document.execCommand(command, false, null)
  }

  _updateInitialTextFieldValue() {
    this.initialTextFieldValue = this.hiddenFieldTarget.value
  }
}
